import { Component, OnInit } from '@angular/core';
import { GroupModel } from '../models/group.model';
import { MatomoTracker } from 'ngx-matomo';
import { DynamicInjectorService } from '@shared/services/dynamic.injector.service';
import { ApiService } from '@shared/services/api.service';

@Component({
  selector: 'app-themes',
  templateUrl: './themes.component.html',
  styleUrls: ['./themes.component.scss']
})
export class ThemesComponent implements OnInit {
  groups: GroupModel[] = [];
  customerName: string;
  showLoading: boolean;

  constructor(
    private apiService: ApiService, 
    private matomoTracker: MatomoTracker,
    private dynamicInjectorService: DynamicInjectorService) {
    this.customerName = this.dynamicInjectorService.getEnvironment().name;
    this.showLoading = true;
    
  }

  ngOnInit() {
    const matomoCategory = `Access Themes page`;
    const matomoAction = 'Overview'
    this.matomoTracker.trackEvent(matomoCategory, matomoAction);
    this.apiService.getThemes().subscribe((groups: GroupModel[]) => {
      groups.forEach(group => {
        group.package_count = null;
        this.groups.push(group);
      });
      let i = 0;
      for (let groupElement of this.groups) {
        this.apiService.getGroupPackageCount(groupElement.name).then((res) => {
          groupElement.package_count = res.count;
          ++i;
          if (i === this.groups.length) {
            this.showLoading = false;
          }
        });
      }
    });
  }

}
